<style lang="scss">
.ad_type {
  .el-form-item__content {
    margin-left: 0px !important;
  }
}

.ad-checkbox {
  margin-bottom: 10px;
}

.cus-radio-group {
  .el-radio {
    margin-bottom: 8px;
    margin-right: 10px;
  }

  .el-radio__label {
    padding-left: 5px;
  }
}

.ad-checkbox-list {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EBEEF5;

  .cus-btn {
    margin-left: 30px !important;
  }
}

.add-advert {
  margin-top: 30px !important;
}

.hot_zone {
  width: 50%;
}

.ad-radio {
  margin-left: 24px;
}
</style>

<template>
  <div>
    <el-form label-position="left" ref="form" :model="form" class="box-set" label-width="120px" :rules="rules"
      v-loading='loading' :disabled="is_expire">
      <el-tabs type="border-card" v-model="form.orderad_type" @tab-click="inputRadioGroup">
        <el-tab-pane v-for="(item, index) in opts.orderad_type" :ket="index + item.value" :label="item.label"
          :name="item.value" :disabled="(form.activity_id > 0) ? true : false">

          <!-- <el-card header="广告类型" shadow="naver" class="ad_type">
        <el-form-item prop="orderad_type" labe="">
          <el-radio-group v-model="form.orderad_type" @input="inputRadioGroup">
            <el-radio-button :disabled="(form.activity_id > 0) ? true : false"
              v-for="(opts_val, opts_key) in opts.orderad_type" :key="opts_key" :label="opts_key"
              @change="changeOrderAdType">{{ opts_val }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-card> -->

          <el-card header="广告位设置（至少设置一个广告位）" shadow="naver" class="ad_type">
            <div class="ad-checkbox-list" v-for="(item, index) in selectOpts[form.orderad_type]" :key="item.value"
              v-if="(form.orderad_page || []).indexOf(item.value) > -1">
              <span>
                {{ item.title }}
                <span v-if="form.orderad_type === 'text' && form.page_reserve[item.value]">（永久保留）</span> ：
              </span>
              <!-- 产品分类页选择 -->
              <div v-if="item.value == 'items_category'">
                <span v-for="(category, category_key) in categoryOptions" :key="category_key"
                  v-if="form.category_id == category.category_id">
                  {{ category.category_name }}<span>&nbsp;>&nbsp;</span>
                </span>
              </div>
              <div>
                <span v-for="(it) in item.page" :key="it.value" v-if="form.page_posno[index] == it.value">
                  {{ it.title }}
                </span>
              </div>
              <el-button class="cus-btn" size="mini" icon="el-icon-setting" type="primary" plain
                @click="showPositionDialog(item, item.value, index)">修改</el-button>
              <el-button size="mini" icon="el-icon-delete" type="primary" plain
                @click="deleteAdvert(item.value, index)">删除</el-button>
            </div>
            <el-button class="add-advert" type="primary" size="medium" @click="addAdvert">添加广告位</el-button>
          </el-card>

          <el-card header="广告基础信息设置" shadow="naver">
            <el-form-item label="广告名称" prop="activity_title">
              <el-col :span="20">
                <el-input v-model="form.activity_title" :maxlength=30 placeholder="最多30个字"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="广告标题" prop="orderad_title" v-if="form.orderad_type == 'text'">
              <el-col :span="20">
                <el-input v-model="form.orderad_title" :maxlength=30 placeholder="最多30个字"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="广告描述" v-if="form.orderad_type == 'text'">
              <el-col :span="20">
                <el-input type="textarea" :rows="3" v-model="form.activity_desc" placeholder="广告描述"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="广告标签" v-if="form.orderad_type == 'text'">
              <el-col :span="20">
                <el-input v-model="form.activity_labels"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="广告图" prop="activity_cover" v-if="form.orderad_type == 'image'">
              <div @click="handleImgChange()" class="upload-box" style="margin-left: 12px;">
                <img v-if="form.activity_cover" :src="wximageurl + form.activity_cover" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg"
                @closeImgDialog="closeImgDialog" />
            </el-form-item>

            <!-- 热区图 -->
            <el-form-item label="热区" v-if="form.orderad_type == 'image'">
              <hotzone v-if="form.orderad_type == 'image'" class="hot_zone" :image="form.activity_cover"
                :zones-init="form.img_hotzone_info" @add="handleAdd" @change="handleChange" @remove="handleRemove">
              </hotzone>
            </el-form-item>

            <div class="setting-item slider" v-for="(item, index) in form.img_hotzone_info" :key="index">
              <!-- 热区连接 -->
              <el-form-item label="热区链接">
                <el-col :span="20">
                  <el-radio-group v-model="item.adavter_type" @change="onAdavterTypeChange($event, index)">
                    <el-radio label="custom">自定义页</el-radio>
                    <el-radio label="compare">机型对比</el-radio>
                    <el-radio label="recommend">机型推荐</el-radio>
                    <el-radio label="registerDrawer">会员注册</el-radio>
                    <el-radio label="thirdpage">第三方小程序跳转</el-radio>
                    <el-radio label="question" v-if="form.orderad_type == 'text'">调查问卷</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
              <el-form-item label="" prop="customize_id">
                <div v-if="item.adavter_type == 'custom'">
                  <el-button size="medium" class="button-new-tag" @click="addCustomizeAction(index)">+ 选择自定义页面
                  </el-button>
                  <div class="goods-select" style=" width: 400px;text-align:left;
                      margin-left: 10px;" v-if="item.customize.customize_id > 0">
                    {{ item.customize.customize_id }} {{ item.customize.customize_title }}
                  </div>
                </div>
                <div v-if="item.adavter_type == 'compare' || item.adavter_type == 'recommend'">
                  <el-form-item>
                    <el-col :span="20">
                      <el-select v-model="item.compare_value" placeholder="请选择">
                        <el-option key="iPhone" label="iPhone" value="iPhone" v-if="adavter_type == 'compare'" />
                        <el-option key="iPad" label="iPad" value="iPad" v-if="adavter_type == 'compare'" />
                        <el-option key="Mac" label="Mac" value="Mac" />
                        <el-option key="Watch" label="Watch" value="Watch" v-if="adavter_type == 'compare'" />
                        <el-option key="Airpods" label="Airpods" value="Airpods" v-if="adavter_type == 'compare'" />
                      </el-select>
                    </el-col>
                  </el-form-item>
                </div>
                <div v-if="item.type == 'question'">
                  <el-button size="medium" class="button-new-tag" @click="addQuestionAction(index)">+ 选择调查问卷
                  </el-button>
                  <div class="goods-select" style=" width: 400px;text-align:left;
                      margin-left: 10px;" v-if="item.customize_id > 0">
                    {{ item.customize.customize_id }} {{ item.customize.customize_title }}
                  </div>
                </div>
                <div v-if="item.adavter_type === 'thirdpage'" class="thirdpage-Link">
                  <el-col :span="6">
                    <el-input v-model="item.customize.linkTitle" placeholder="请输入跳转小程序的页面路径"></el-input>
                    <el-input v-model="item.customize.linkAppid" placeholder="请输入跳转小程序的APPID"></el-input>
                  </el-col>
                </div>
              </el-form-item>
            </div>
            <el-form-item label="有效期" prop="orderad_time">
              <el-col :span="20">
                <el-date-picker v-model="form.orderad_time" type="datetimerange" value-format="timestamp"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                  align="right" :default-time="['00:00:00', '23:59:59']" :disabled="itemChecked"
                  @change="activityDateTimeChange" />

                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
                </el-checkbox-group>

              </el-col>
            </el-form-item>
            <el-form-item label="可见范围" prop="member_type">
              <el-col :span="20">
                <el-radio-group v-model="form.member_type">
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button label="member">仅会员</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-form-item>
            <el-form-item label="广告链接" v-show="form.img_hotzone_info.length === 0">
              <el-col :span="20">
                <el-radio-group v-model="adavter_type" @change="onAdavterTypeChange">
                  <el-radio label="custom">自定义页</el-radio>
                  <el-radio label="compare">机型对比</el-radio>
                  <el-radio label="recommend">机型推荐</el-radio>
                  <el-radio label="thirdpage">第三方小程序跳转</el-radio>
                  <!-- <el-radio label="question" v-if="form.orderad_type == 'text'">调查问卷</el-radio> -->
                  <el-radio label="question">调查问卷</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
            <el-form-item label="" prop="customize_id" v-show="form.img_hotzone_info.length === 0">
              <div v-if="adavter_type == 'custom'">
                <el-button size="medium" class="button-new-tag" @click="addCustomizeAction('')">+ 选择自定义页面 </el-button>
                <div class="goods-select" style=" width: 400px;text-align:left;
                  margin-left: 10px;" v-if="form.page_link.customize_id > 0">
                  {{ form.page_link.customize_id }} {{ form.page_link.customize_title }}
                </div>
              </div>
              <div v-if="adavter_type == 'compare' || adavter_type == 'recommend'">
                <el-form-item>
                  <el-col :span="20">
                    <el-select v-model="compare_value" placeholder="请选择">
                      <el-option key="iPhone" label="iPhone" value="iPhone" v-if="adavter_type == 'compare'" />
                      <el-option key="iPad" label="iPad" value="iPad" v-if="adavter_type == 'compare'" />
                      <el-option key="Mac" label="Mac" value="Mac" />
                      <el-option key="Watch" label="Watch" value="Watch" v-if="adavter_type == 'compare'" />
                      <el-option key="Airpods" label="Airpods" value="Airpods" v-if="adavter_type == 'compare'" />
                    </el-select>
                  </el-col>
                </el-form-item>
              </div>
              <div v-if="adavter_type == 'question'">
                <el-button size="medium" class="button-new-tag" @click="addQuestionAction('')">+ 选择调查问卷 </el-button>
                <div class="goods-select" style=" width: 400px;text-align:left;
                  margin-left: 10px;" v-if="form.page_link.customize_id > 0">
                  {{ form.page_link.customize_id }} {{ form.page_link.customize_title }}
                </div>
              </div>
              <div v-if="adavter_type === 'thirdpage'" class="thirdpage-Link">
                <el-col :span="6">
                  <el-input v-model="linkTitle" placeholder="请输入跳转小程序的页面路径"></el-input>
                  <el-input v-model="linkAppid" placeholder="请输入跳转小程序的APPID"></el-input>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item v-if="form.orderad_type == 'text'" label="文案背景色">
              <el-col :span="20">
                <el-color-picker v-model="form.color_one"></el-color-picker>&nbsp;&nbsp;
                <el-color-picker v-model="form.color_two"></el-color-picker>
              </el-col>
            </el-form-item>
            <el-form-item v-if="form.orderad_type == 'text'" label="文案颜色">
              <el-col :span="20">
                <el-color-picker v-model="form.text_color"></el-color-picker>
              </el-col>
            </el-form-item>
          </el-card>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-card header="适用商品" shadow="naver" class="ad_type">
                <el-form-item label="">
                  <el-radio-group v-model="form.use_bound" @change="itemTypeChange">
                    <el-radio label="all">全部商品</el-radio>
                    <el-radio label="goods">按指定商品</el-radio>
                  </el-radio-group>
                </el-form-item>
                <SkuSelector v-if="!zdItemHidden" @change="getItems" @processing-change="handleGoodsProcessing"
                  @processing-error="handleGoodsProcessingError" :can-edit="!is_expire" :data="relItems">
                </SkuSelector>
              </el-card>
            </el-col>
          </el-row>
          <div class="content-center">
            <div v-if="goodsProcessing" style="margin-bottom: 12px; color: #e6a23c;">
              <i class="el-icon-loading" style="margin-right: 6px;"></i>商品数据处理中，请稍等
            </div>
            <el-button type="primary" @click="submitActivityAction('form')"
              :disabled="saveload || goodsProcessing" v-loading="saveload">保存</el-button>
            <el-button @click.native="handleCancel">返回</el-button>
          </div>

        </el-tab-pane>
      </el-tabs>
      <!-- 选择广告位展示页面 -->
      <el-dialog title="选择广告位" :visible.sync="dialogFormVisible" width="30%" :before-close="addAdvert">
        <el-form-item label="" prop="orderad_page">
          <!-- TODO 三次优化 -->
          <!-- 选择广告展示页面 -->
          <el-select v-model="rderadPageValue" :disabled="isRderadPageEdit" @change="handleOrderadPage" placeholder="请选择广告位">
            <el-option v-for="(item) in selectOpts[form.orderad_type]" :key="item.value" :label="item.title"
              :value="item.value" />
          </el-select>
          <!-- 产品分类页选择分类 -->
          <el-select v-if="rderadPageValue === 'items_category'" v-model="form.category_id" placeholder="请选择分类">
            <el-option v-for="(category, category_key) in categoryOptions" :key="category_key"
              :label="category.category_name" :value="category.category_id" />
          </el-select>
          <!-- 选择广告展示位置（优化循环判断） -->
          <el-select v-if="currentPageItem" v-model="pagePosnoValue" placeholder="请选择广告展示位">
            <el-option v-for="(it) in currentPageItem.page" :key="it.value" :label="it.title" :value="it.value" />
          </el-select>
          <!-- 合并重复的开关组件 -->
          <component :is="showReserve ? 'el-form' : 'div'" style="float: right; margin-top: -3px">
            <el-switch v-if="form.orderad_type === 'text' && rderadPageValue === 'order_detail'"
              v-model="form.page_reserve[rderadPageValue]" @change="reserveChange" inactive-text="永久保留广告" />
          </component>
        </el-form-item>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addAdvert('submit')">确 定</el-button>
        </span>
      </el-dialog>
    </el-form>
    <CustomizeSelect :store-visible="CustomizeVisible" :is-valid="true" :rel-data-ids="customizeList"
      :get-status="CustomizeStatus" @chooseStore="CustomizeChooseAction" @closeStoreDialog="closeStoreDialog" />
    <QuestionnaireSelect :visible="questionVisible" :radioId="form.page_link.customize_id" @saveAction="saveAction"
      @closeDialog="closeDialog" />
  </div>
</template>

<script>
import hotzone from 'vue-hotzone'
import { getPreferentialInfo, createPreferential, updatePreferential } from '@/api/promotions'
import SkuSelector from '@/components/function/skuSelector'
import CustomizeSelect from '@/components/function/customizeSelect'
import QuestionnaireSelect from '@/components/function/questionnaireSelect'
import imgPicker from '@/components/imageselect'
import { getItemsList, getCategory, getSkuList } from '@/api/goods'

export default {
  inject: ['refresh'],
  components: {
    SkuSelector,
    imgPicker,
    CustomizeSelect,
    QuestionnaireSelect,
    hotzone
  },
  data() {
    return {
      loading: false,
      saveload: false,
      goodsProcessing: false,
      goodsProcessingCount: 0,
      relItems: [],
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() < new Date(new Date(new Date().toLocaleDateString()).getTime());
        // },
      },
      is_expire: false,
      showReserve: true,
      form: {
        activity_id: 0,
        orderad_type: '',// 广告位管理名称
        orderad_page: [],// 广告位关联页面
        page_posno: {},// 广告位配置信息
        page_reserve: {}, // 永久保留广告信息
        page_link: {},// 广告链接配置
        activity_title: '',// 广告名称
        activity_desc: '',// 广告描述
        activity_cover: '',// 广告图
        orderad_title: '',// 广告文案
        activity_labels: '',// 广告标签
        customize_info: {},
        use_bound: 'goods',
        item_category: [],
        items: [],
        color_one: '#FD7624',
        color_two: '#FD7624',
        text_color: '#ffffff',
        start_time: 0,
        end_time: 0,
        customize_id: '0',
        orderad_time: '',
        img_hotzone_info: [],
        long_time: false,
        category_id: '',
        member_type: 'all'
      },
      rules: {
        orderad_type: [{ required: true, message: '请选择广告类型', trigger: 'blur' }],
        activity_title: [{ required: true, message: '请输入广告名称', trigger: 'blur' },
        { pattern: /^.{2,30}$/, message: '只能输入2-30个字' }],
        orderad_time: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
        activity_desc: [{ required: true, message: '请输入广告描述', trigger: 'blur' },
        { pattern: /^.{2,30}$/, message: '只能输入2-30个字' }],
        orderad_page: [{ required: true, message: '请选择广告展示页', trigger: 'blur' }],
        page_posno: [{ required: true, message: '请选择广告展示页2', trigger: 'blur' }],
        orderad_title: [{ required: true, message: '请输入广告标题', trigger: 'blur' },
        { pattern: /^.{2,30}$/, message: '只能输入2-30个字' }],
        activity_cover: [{ required: true, message: '请上传广告图', trigger: 'blur' }],
        // customize_id: [{required: true, message: '请配置跳转页面', trigger: 'blur'}],
        color_one: [{ required: true, message: '请配置文案背景色', trigger: 'blur' }],
        color_two: [{ required: true, message: '请配置文案背景色', trigger: 'blur' }],
        text_color: [{ required: true, message: '请配置文案颜色', trigger: 'blur' }]
      },
      // 添加广告位dialog控制
      dialogFormVisible: false,
      selectOpts: {
        text: [
          {
            title: '商品详情',
            value: 'item_detail',
            page: [
              {
                title: '轮播提示栏',
                value: 'rotation'
              },
              {
                title: '礼遇',
                value: 'courtesy'
              }
            ]
          },
          {
            title: '订单确认页',
            value: 'order_confirm',
            page: [
              {
                title: '商品赠券区域',
                value: 'item_gift_card'
              }
            ]
          },
          {
            title: '订单详情页',
            value: 'order_detail',
            page: [
              {
                title: '商品赠券区域',
                value: 'order_gift_card'
              }
            ]
          },
          {
            title: '售后维修',
            value: 'after_sales',
            page: [
              {
                title: '广告位1',
                value: 'after_sales_card'
              }
            ]
          },
          {
            title: '支付成功页',
            value: 'payment_success',
            page: [
              {
                title: '礼遇',
                value: 'courtesy'
              }
            ]
          }
        ],
        image: [
          {
            title: '商品详情',
            value: 'item_detail',
            page: [
              {
                title: '详情介绍上方区域',
                value: 'item_info_top'
              },
              {
                title: '详情介绍底部区域',
                value: 'item_info_bottom'
              }
            ]
          },
          {
            title: '订单详情页',
            value: 'order_detail',
            page: [
              {
                title: '订单信息和寻求帮助中间',
                value: 'order_info'
              },
              {
                title: '页面最底部',
                value: 'order_foot'
              }
            ]
          },
          {
            title: '分类产品页',
            value: 'items_category',
            page: [
              {
                title: '分类页货架底部',
                value: 'shelf_bot'
              },
              {
                title: '分类页底部',
                value: 'page_bot'
              },
              {
                title: '分类页顶部',
                value: 'shelf_top_bot'
              }
            ]
          },
          {
            title: '首页',
            value: 'home_page',
            page: [
              {
                title: '首页开屏广告',
                value: 'home_open_ad'
              },
            ]
          },
          {
            title: '支付成功页',
            value: 'payment_success',
            page: [
              {
                title: '为你推荐与专属服务之间',
                value: 'recommend_foot'
              },
              {
                title: '页面最底部',
                value: 'exclusive'
              },
              {
                title: '为你推荐上方',
                value: 'recommend_top'
              },
            ]
          },
        ]
      },
      opts: {
        orderad_type: [
          {
            value: 'text',
            label: '文字广告'
          },
          {
            value: 'image',
            label: '图片广告'
          }
        ],
      },
      imgDialog: false,
      isGetImage: false,
      zdItemHidden: false,
      hasSaveButton: true,
      categoryList: [],
      CustomizeStatus: false,
      CustomizeVisible: false,
      customize: '',
      customizeList: [],
      sort: 1,
      dateTime: '',
      questionVisible: false,
      compare_value: 'iPhone',
      adavter_type: 'custom',
      linkTitle: '',
      linkAppid: '',
      page_detail_link: {},
      img_hotzone_link: [], // 保存接口获取的img_hotzone_link_obj 信息
      editImgHotzoonIndex: '',
      checkedCities: [],
      cities: ['永久有效'],
      itemChecked: false,
      categoryOptions: [],
      // select选择的广告位值
      rderadPageValue: '',
      pagePosnoValue: '',
      isRderadPageEdit: false, // 是否可修改广告位
    }
  },
  computed: {
    currentPageItem() {
      return this.selectOpts[this.form.orderad_type]?.find(
        item => item.value === this.rderadPageValue
      )
    }
  },
  watch: {},
  methods: {
    async getCategoryOptions() {
      const { data } = await getCategory()
      this.categoryOptions = data.data
    },
    // 热区路径
    showLinks(index, _dataIndex) {
      console.log('00000', index)
      this.linksVisible = true
      if (index !== undefined) {
        this.editorDataIndex = index;
      }
      if (_dataIndex !== undefined) {
        this.editorZoneIndex = _dataIndex;
      }
    },
    // 增加热区
    handleAdd() {
      let item = {
        customize: {
          customize_id: '',
          customize_title: '',
          type: '',
          linkTitle: '',
          linkAppid: ''
        },
        compare_value: '',
        type: '',
        adavter_type: '',

      }
      this.form.img_hotzone_info.push(item)
    },
    // 修改热区
    handleChange(zone) {
      setTimeout(() => {
        zone.forEach((item, index) => {
          if (item.leftPer) {
            let obj = {
              heightPer: item.heightPer,
              leftPer: item.leftPer,
              topPer: item.topPer,
              widthPer: item.widthPer
            }
            Object.assign(this.form.img_hotzone_info[index], obj)
          }
        })
      }, 500)
    },
    // 删除热区
    handleRemove(index) {
      this.form.img_hotzone_info.splice(index, 1)
    },

    handleChangeCheckbox(item, index, isCheck) {
      // 点击checkbox后，如果下面只有一个的话，选中下面的radio
      // console.log('isCheck===>',item,isCheck,index);
      if (isCheck) {
        if (Object.keys(item.page).length === 1) {
          this.form.page_posno[index] = Object.keys(item.page)[0]
        }
      } else {
        // 取消选中checkbox后，radio去除选择
        delete this.form.page_posno[index]
      }
    },
    activityDateTimeChange() {
      const dateTime = JSON.parse(JSON.stringify(this.form.orderad_time))
      if (dateTime) {
        this.form.start_time = dateTime[0] === undefined ? 0 : dateTime[0] / 1000
        this.form.end_time = dateTime[1] === undefined ? 0 : dateTime[1] / 1000
      } else {
        this.form.start_time = this.form.end_time = 0
      }
    },
    changeOrderAdType() {
      this.form.orderad_page = [];
      this.form.page_posno = {};
      if (this.form.orderad_type == 'text') {
        this.form.activity_cover = '';
      } else {
        this.form.activity_desc = '';
        this.form.orderad_title = '';
        this.from.activity_labels = ''
      }
    },
    reserveChange(val) {
      let msg = '关闭后，若广告失效，用户的历史订单详情页将不再保留该广告内容，确定关闭？'
      if (val) {
        msg = '开启后，用户在广告有效期内下单指定商品的订单详情页将永久保留该广告内容，确定开启？'
      }
      this.form.page_reserve['order_detail'] = !val
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.page_reserve['order_detail'] = val
      })

    },
    // 保存
    submitActivityAction(formName) {
      if (this.goodsProcessing) {
        this.$message.warning('商品数据正在处理中，请稍等')
        return false
      }
      var is_check = 1;// 验证是否允许提交
      console.log('form data', this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          is_check = 2;
          console.log('submit!!');
        } else {
          console.log('check error.');
          return false;
        }
      });
      if (is_check == 1) {
        return false;
      }
      if (this.form.orderad_page.length == 0) {
        this.$message({
          message: '请选择广告位',
          type: 'error',
          duration: 2000
        });
        return false;
      }
      if (Object.keys(this.form.page_posno).length == 0) {
        this.$message({
          message: '请选择广告位',
          type: 'error',
          duration: 2000
        });
        return false;
      }
      let itemlen = 0;
      if (this.form.items != undefined) {
        itemlen = this.form.items.length;
      }
      if (this.form.use_bound != 'all' && itemlen == 0) {
        this.$message({
          message: '请选择商品',
          type: 'error',
          duration: 2000
        });
        return false;
      }
      if (this.saveload) {
        return false;
      }
      this.saveload = true;
      var params = this.activityItemField(this.form);
      console.log('params: ', params);
      // return false;
      if (this.form.activity_id > 0) {// edit
        updatePreferential(this.form.activity_id, params).then(response => {
          const that = this
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 2000,
            onClose() {
              that.refresh();
              that.handleCancel()
            }
          })
        })
      } else {// add
        // console.log('submit params: ', params);
        params.activity_subtitle = ""

        createPreferential(params).then(res => {
          const that = this
          this.$message({
            message: '添加成功',
            type: 'success',
            duration: 2000,
            onClose() {
              that.refresh();
              that.handleCancel()
            }
          })
        })
      }
    },
    // 组装热区图
    handleHotzoneCompare() {
      if (this.form.img_hotzone_info) {
        this.form.img_hotzone_info.map((item) => {
          if (item.adavter_type === 'compare' || item.adavter_type == 'recommend') {
            item.customize.customize_title = item.compare_value
          }
          item.customize.type = item.adavter_type
        })
      }
    },

    // 组装自定义字段 用于提交表单
    activityItemField(form) {
      let itemConf = []
      if (form.items[0] != undefined) {
        itemConf = form.items;
      }
      let orderadConf = {
        type: form.orderad_type,
        title: form.orderad_title,
        labels: form.activity_labels,
        desc: form.activity_desc,
        color_one: form.color_one,
        color_two: form.color_two,
        text_color: form.text_color,
        use_bound: form.use_bound,
        items: itemConf,
        page_link: form.page_link,
        page_arr: form.orderad_page,
        page_pos: form.page_posno,
        page_reserve: form.page_reserve,
        sort: this.sort,
        img_hotzone_info: form.img_hotzone_info,
        category_id: form.category_id,
      };
      orderadConf.page_link.type = this.adavter_type || 'custom' // 广告链接类型
      if (this.adavter_type == 'thirdpage') {
        orderadConf.page_link.linkTitle = this.linkTitle || '' // 跳转的小程序路径
        orderadConf.page_link.linkAppid = this.linkAppid || '' // 跳转的小程序appid
      }
      if (this.adavter_type == 'compare' || this.adavter_type == 'recommend') {
        orderadConf.page_link.customize_title = this.compare_value
      }
      this.handleHotzoneCompare()
      let customize_id = '0';
      if (form.page_link.customize_id != undefined) {
        customize_id = form.page_link.customize_id;
      }
      return {
        'activity_title': form.activity_title,// 标题
        'activity_labels': form.activity_labels,// 标签
        'activity_cover': form.activity_cover,// 背景图
        'customize_id': customize_id,//自定义页面id
        'type': 'orderAD',// 广告管理
        'distributor_ids': 0,
        'start_time': form.start_time,
        'end_time': form.end_time,
        'city_list': '',
        'rel_city': '',
        'items': orderadConf,
        'long_time': form.long_time,
        'member_type': form.member_type,
      };
    },
    // 修改，页面初始化处理保存过的数据
    getActivityDetail(id) {
      this.loading = true;
      getPreferentialInfo(id).then(res => {
        this.loading = false;
        let response = res.data.data
        console.log('response: ', response);
        this.is_expire = response.is_expire
        let config = response.items_arr;
        for (const i in config.page_reserve) {
          config.page_reserve[i] = config.page_reserve[i] === 'true' ? true : false
        }
        if (!config.page_reserve) {
          config.page_reserve = {}
        }
        config.page_link = config.page_link || {}
        this.page_detail_link = config.page_link
        this.img_hotzone_link = config.img_hotzone_info && [...config.img_hotzone_info] || []
        let data = {};
        if (response.is_expire && ((config.page_reserve['order_detail'] && config.page_reserve['order_detail'] === 'false') || !config.page_reserve['order_detail'])) {
          this.showReserve = false
        }

        if (config.type) {// 新活动
          let page_link = {
            customize_id: '0',
            customize_title: ''
          }
          if (config.page_link && config.page_link.customize_id != undefined) {
            page_link.customize_id = config.page_link.customize_id;
            page_link.customize_title = config.page_link.customize_title;
          }
          var itemConf = [];
          if (config.items && config.items[0] != undefined && config.items[0].item_id != undefined) {
            itemConf = config.items;
          }
          console.log("🚀 ~ getPreferentialInfo ~ response:", response)

          data = {
            activity_id: id,
            orderad_type: config.type,// 广告位管理名称
            orderad_page: Array.isArray(config.page_arr) ? config.page_arr : [],// 广告位关联页面
            page_posno: config.page_pos,// 广告位配置信息
            page_reserve: config.page_reserve,// 永久保留信息
            page_link: page_link,// 广告链接配置
            activity_title: response.activity_title,// 广告名称
            activity_desc: config.desc,// 广告描述
            activity_cover: response.activity_cover,// 广告图
            orderad_title: config.title,// 广告文案
            activity_labels: response.activity_labels,
            customize_info: {},
            use_bound: config.use_bound,
            item_category: itemConf,
            color_one: config.color_one,
            color_two: config.color_two,
            text_color: config.text_color,
            items: itemConf,
            customize_id: '0',
            start_time: response.start_time,
            end_time: response.end_time,
            img_hotzone_info: config.img_hotzone_info || [],
            long_time: response.long_time || false,
            category_id: config.category_id,
            member_type: response.member_type,
          }

          // 设置永久有效
          if (response.long_time) {
            this.checkedCities = this.cities
            this.itemChecked = response.long_time
          }

          if (data.page_link && data.page_link.customize_id != undefined) {
            data.customize_id = data.page_link.customize_id;
          }
          this.form.orderad_time = [data.start_time * 1000, data.end_time * 1000]
        } else {
          let def_type = 'image';
          let page_link = {
            customize_id: config.customize_id | '0',
            customize_title: config.customize_title | '',
          }
          data = {
            activity_id: id,
            orderad_type: def_type,// 广告位管理名称, 老数据默认为图片
            orderad_page: [config.page_type],// 广告位关联页面
            page_posno: {},// 广告位配置信息
            page_reserve: {},// 永久保留信息
            page_link: page_link,// 广告链接配置
            activity_title: response.activity_title,// 广告名称
            activity_desc: '',// 广告描述
            activity_cover: response.activity_cover,// 广告图
            orderad_title: '',// 广告文案
            activity_labels: '',
            customize_info: {},
            use_bound: 'goods',
            item_category: [],
            color_one: '',
            color_two: '',
            items: [],
            customize_id: config.customize_id
          }
        }
        this.adavter_type = config.page_link.type || 'custom'
        if (this.adavter_type == 'thirdpage') {
          this.linkTitle = config.page_link.linkTitle || '' // 跳转的小程序路径
          this.linkAppid = config.page_link.linkAppid || '' // 跳转的小程序appid
        }
        if (this.adavter_type == 'compare' || this.adavter_type == 'recommend') {
          this.compare_value = config.page_link.customize_title || ''
        }
        Object.assign(this.form, data)
        console.log('response_form: ', this.form);
        this.relItems = response.itemTreeLists || []
        this.sort = config.sort | 1
        this.zdItemHidden = true
        if (this.form.use_bound == 'goods') {
          this.zdItemHidden = false;
        }
      })
    },
    handleCancel() {
      this.$router.back(-1)
    },
    itemTypeChange(val) {
      this.zdItemHidden = true
      this.form.items = []
      if (val === "goods") {
        this.zdItemHidden = false
      }
    },
    handleGoodsProcessing(processing) {
      if (processing) {
        this.goodsProcessingCount += 1
      } else {
        this.goodsProcessingCount = Math.max(0, this.goodsProcessingCount - 1)
      }
      this.goodsProcessing = this.goodsProcessingCount > 0
    },
    handleGoodsProcessingError(error) {
      console.error('[OrderAD] 商品数据处理失败', error)
      this.$message.error('商品数据处理失败，请重新选择商品')
    },
    getItems(data) {
      this.ItemsList = []
      let items = []
      data.forEach(item => {
        var itemData = {
          'item_id': item.item_id
        }
        if (this.limit_num_type === 'spu') { // 限购维度为spu时，只存储一条记录
          if (item.is_default == '1') {
            items.push(itemData)
          }
        } else {
          items.push(itemData)
        }

        this.ItemsList.push(item);
      })
      this.form.items = items
    },
    // 图片选择弹层相关方法
    pickImg(data) {
      this.form.activity_cover = data.url
      this.imgDialog = false
    },
    closeImgDialog() {
      this.imgDialog = false
    },
    handleImgChange() {// 上传卡封面
      this.imgDialog = true
      this.isGetImage = true
    },
    closeStoreDialog() {
      this.CustomizeStatus = false
      this.CustomizeVisible = false
    },

    addCustomizeAction(index) {
      this.CustomizeStatus = true
      this.CustomizeVisible = true
      this.editImgHotzoonIndex = index
    },
    // 选择的自定义页面
    CustomizeChooseAction(data) {
      this.CustomizeVisible = false
      this.CustomizeStatus = false
      if (data === null || data.length <= 0) return
      // console.log("CustomizeChooseAction CustomizeChooseAction------------------data:", data)
      // console.log('this.editImgHotzoonIndex',this.editImgHotzoonIndex,99)
      if (this.editImgHotzoonIndex !== '') {
        // 加上热区图的选择连接
        this.form.img_hotzone_info[this.editImgHotzoonIndex].customize.customize_id = data[0].id
        this.form.img_hotzone_info[this.editImgHotzoonIndex].customize.customize_title = data[0].page_name
        this.editImgHotzoonIndex = ''
      } else {
        // 兼容旧版本，整个页面的链接数据
        this.form.customize_info = data[0]
        this.form.page_link.customize_id = data[0].id
        this.form.page_link.customize_title = data[0].page_name
        this.form.customize_id = this.form.page_link.customize_id
      }
    },
    // 选择调查问卷
    addQuestionAction(index) {
      this.questionVisible = true
      this.editImgHotzoonIndex = index
    },
    // 调查问卷选择结果
    saveAction(data) {
      this.closeDialog()
      if (data === null || data.length <= 0) return

      if (this.editImgHotzoonIndex !== '') {
        // 热区图问卷调查数据
        this.form.img_hotzone_info[editImgHotzoonIndex].customize.customize_id = data[0].id
        this.form.img_hotzone_info[editImgHotzoonIndex].customize.customize_title = data[0].tpl_name
        this.editImgHotzoonIndex = ''
      } else {
        // 兼容旧版本，非热区图
        this.form.customize_info = data[0]
        this.form.page_link.customize_id = data[0].id
        this.form.page_link.customize_title = data[0].tpl_name
        this.form.customize_id = data[0].id
      }
    },
    closeDialog() {
      this.questionVisible = false
    },
    // 清空已选链接
    onAdavterTypeChange(value, imgHotZoonIndex) {
      console.log(value, imgHotZoonIndex, 111)
      if (imgHotZoonIndex) {
        const link_type = this.img_hotzone_link.length && this.img_hotzone_link[imgHotZoonIndex] && this.img_hotzone_link[imgHotZoonIndex].type || 'custom'
        if (value != link_type) {
          this.form.img_hotzone_info[imgHotZoonIndex].customize = { customize_id: '', customize_title: '', type: '' }
        } else {
          this.form.img_hotzone_info[imgHotZoonIndex].customize = this.img_hotzone_link.length && this.img_hotzone_link[imgHotZoonIndex] && this.img_hotzone_link[imgHotZoonIndex].customize || { customize_id: '', customize_title: '', type: '' }
        }
      } else {
        // 兼容旧版本，非热区图
        const link_type = this.page_detail_link.type || 'custom'
        if (value != link_type) {
          this.form.page_link = {}
        } else {
          this.form.page_link = this.page_detail_link
        }
      }
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length > 0 ? true : false
      this.form.long_time = checkedCount
      this.itemChecked = checkedCount
      this.form.orderad_time = ''
      this.form.start_time = this.form.end_time = 0
      // checkedCount为true时，不需要rules对orderad_time的校验
      if (checkedCount) {
        this.rules.orderad_time = []
      } else {
        this.rules.orderad_time = [{ required: true, message: '请选择有效期', trigger: 'blur' }]
      }
    },
    inputRadioGroup(v) {
      if (v == 'text') {
        this.form.long_time = false
        this.itemChecked = false
        this.checkedCities = []
      }
    },
    // 添加广告位
    addAdvert(type) {
      // 提交时的校验逻辑
      if (type === 'submit' && this.dialogFormVisible) {
        // 校验广告位选择
        if (!this.rderadPageValue) {
          return this.$message.error('请选择广告位')
        }
        if (this.rderadPageValue == 'items_category' && !this.form.category_id) {
          return this.$message.error('请选择分类')
        }
        // 校验展示位置选择
        if (!this.pagePosnoValue) {
          return this.$message.error('请选择展示位置')
        }

        // 处理已选广告位页面（去重添加）
        const selectedPages = [...this.form.orderad_page]
        if (!selectedPages.includes(this.rderadPageValue)) {
          selectedPages.push(this.rderadPageValue)
        }
        this.form.orderad_page = selectedPages

        // 处理广告位展示位置（直接定位索引赋值，避免全量循环）
        const positionOptions = this.selectOpts[this.form.orderad_type]
        const targetIndex = positionOptions.findIndex(item => item.value === this.rderadPageValue)
        if (targetIndex !== -1) {
          this.form.page_posno[targetIndex] = this.pagePosnoValue
        }
      } else {
        this.rderadPageValue = ''
        this.pagePosnoValue = ''
      }
      this.dialogFormVisible = !this.dialogFormVisible
      this.isRderadPageEdit = false
    },
    // 选择展示位置弹窗控制
    showPositionDialog(item, page_key, index) {
      this.rderadPageValue = item.value
      this.pagePosnoValue = this.form.page_posno[index] || ''
      this.dialogFormVisible = !this.dialogFormVisible
      this.isRderadPageEdit = true
    },
    // 删除广告位
    deleteAdvert(val, index) {
      let arr = JSON.parse(JSON.stringify(this.form.orderad_page))
      let idx = arr.findIndex(item => item == val)
      arr.splice(idx, 1)
      this.form.orderad_page = arr
      this.$delete(this.form.page_posno, index);
    },
    // 选择广告位弹窗广告位选择后
    handleOrderadPage(val) {
      // 直接获取对应类型的选项，无需额外复制数组
      const targetItem = this.selectOpts[this.form.orderad_type].find(
        item => item.value === val
      );
      // 找到目标项后处理页面位置值
      if (targetItem) {
        // 简化逻辑：根据page长度直接赋值
        this.pagePosnoValue = targetItem.page.length === 1 ? targetItem.page[0].value : '';
      }
    }
  },
  mounted() {
    console.log('query : ', this.$route.query);
    if (this.$route.query.id) {
      this.getActivityDetail(this.$route.query.id)
    } else {
      this.$set(this.form, 'orderad_type', 'image')
    }
    this.getCategoryOptions()
  },
}
</script>
